module.exports = __webpack_public_path__ + "img/avatar.7d42e2be.jpg";